import React from "react";

/**
 * Universal team representation across the app.
 * Renders the football-data.org crest if available, falls back to flag emoji,
 * with the 3-letter TLA code visible at all sizes.
 */
export default function TeamBadge({ team, size = "md", showName = true, hideCodeOnMobile = false, className = "" }) {
  // Empty/unknown team (e.g. an undetermined knockout opponent) → render a TBD chip.
  const isEmpty = !team || (!team.name && !team.code && !team.crest && !team.flag && !team.shortName);
  if (isEmpty) {
    const crestSize = size === "lg" ? "w-7 h-7" : size === "sm" ? "w-4 h-4" : "w-5 h-5";
    const codeSize = size === "lg" ? "text-sm" : "text-xs";
    return (
      <span className={`inline-flex items-center gap-2 min-w-0 ${className}`} data-testid="team-tbd">
        <span className={`${crestSize} flex items-center justify-center flex-shrink-0`} aria-hidden>
          <span className="text-base leading-none">🏁</span>
        </span>
        <span className={`${codeSize} font-display tracking-widest text-zinc-500`}>TBD</span>
      </span>
    );
  }
  const crestSize = size === "lg" ? "w-7 h-7" : size === "sm" ? "w-4 h-4" : "w-5 h-5";
  const codeSize = size === "lg" ? "text-sm" : "text-xs";
  const nameSize = size === "lg" ? "text-base" : size === "sm" ? "text-xs" : "text-sm";
  const crest = team.crest || team.flag_url;
  const code = team.code || team.tla || "???";

  return (
    <span className={`inline-flex items-center gap-2 min-w-0 ${className}`}>
      {crest ? (
        <img src={crest} alt="" className={`${crestSize} object-contain flex-shrink-0`} loading="lazy" />
      ) : team.flag ? (
        <span className={`${crestSize} flex items-center justify-center flex-shrink-0`} aria-hidden>
          <span className="text-lg leading-none">{team.flag}</span>
        </span>
      ) : (
        <span className={`${crestSize} bg-zinc-800 text-zinc-400 flex items-center justify-center flex-shrink-0 ${codeSize} font-display`}>
          {code.slice(0, 1)}
        </span>
      )}
      <span className={`${codeSize} font-display tracking-widest text-zinc-400 ${hideCodeOnMobile ? "hidden sm:inline" : ""}`}>{code}</span>
      {showName && <span className={`${nameSize} font-display tracking-wider truncate`}>{team.shortName || team.name}</span>}
    </span>
  );
}
